var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repairPolicy-container"},[_c('div',[_c('div',{staticClass:"repairPolicy-main",domProps:{"innerHTML":_vm._s(_vm.desc)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }